import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, formatPrice } from "@/lib/api";
import { useCurrency } from "@/context/CurrencyContext";

export default function Wishlist() {
  const { user } = useAuth();
  const { currency } = useCurrency();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!user || !user.wishlist?.length) return;
    (async () => {
      const results = await Promise.all(
        user.wishlist.map((id) => api.get(`/products?limit=100`).then((r) => r.data.find((p) => p.product_id === id)))
      );
      setProducts(results.filter(Boolean));
    })();
  }, [user]);

  if (!user) {
    return (
      <main className="pt-40 pb-40 text-center px-6" data-testid="wishlist-signin">
        <h1 className="font-serif text-4xl">Sign in to save pieces.</h1>
        <Link to="/login" className="mt-6 inline-block btn-editorial">Sign in</Link>
      </main>
    );
  }

  return (
    <main className="pt-24 md:pt-32 pb-24 px-6 md:px-12 lg:px-16" data-testid="wishlist-page">
      <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B]">Your Wishlist</p>
      <h1 className="font-serif text-4xl md:text-5xl mt-3 mb-10">Kept for later.</h1>
      {products.length === 0 ? (
        <p className="text-[#7A7A7A] text-sm" data-testid="wishlist-empty">Nothing saved yet — tap the heart on any product.</p>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-4 md:gap-x-6 gap-y-12">
          {products.map((p) => (
            <Link to={`/product/${p.slug}`} key={p.product_id} className="product-card group" data-testid={`wishlist-item-${p.slug}`}>
              <div className="aspect-[3/4] overflow-hidden bg-[#F3EFEA]">
                <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <p className="font-serif text-lg mt-3">{p.name}</p>
              <p className="text-sm text-[#4A4A4A]">{formatPrice(p.price_inr, currency)}</p>
            </Link>
          ))}
        </div>
      )}
    </main>
  );
}
